<div class="crosslinkingBox">
  <div class="headingPage">
    <h2 class="">Select Story URL</h2>
  </div>
  <div class="searchBlock">
  
  <div class="searchSection">  <i class="icomoon icon-link"></i>
    <div class="searchtxt searchaddlink">
      <input class="search-components textBox" type="text"
      placeholder="Enter Hyperlink URL..."
      [(ngModel)]="hyperlinkUrl" autofocus/>
      <button (click)="sendStoryToParent()" class="blueAng">Add Link</button>
    </div>
  </div>

  <div class="searchSection">   <i class="icon-search"></i>
    <div class="searchtxt">
      <input [formControl]='searchQuery' class="search-components textBox" type="text"
      placeholder="Search Stories..."
      [(ngModel)]="topicName" autofocus/>
    </div>
  </div>

</div>
  <div class="keywordList">
    <div class="scrollY">
      <ul>
        <h3>Topic Listing</h3>
    <ng-container *ngIf="listArrayTopic.length > 0">
      <ng-container *ngFor="let item of listArrayTopic.slice(0, 3); trackBy: trackByName; let i = index">
        <li (click)="getPageurlforTopic(item)">
          <div class="title"> {{item.name}} </div>
          <div class="url"> {{item.url}} </div>
        </li>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="listArrayTopic.length === 0">
      <div class="title">No Records found!</div>
    </ng-container>
      </ul>
  <ul>
    <h3>Story Listing</h3>
    <ng-container *ngIf="listArray.length > 0">
      <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
        <li (click)="getPageurl(item)">
          <div class="title"> {{item.title}} </div>
          <div class="url"> {{item.metadata.url}} </div>
          <div class="firstpub"> {{getNewTypeDate(item.firstPublishedDate)}} </div>
        </li>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="listArray.length === 0">
      <div class="title">No Records found!</div>
    </ng-container>

  </ul>
</div>
</div>
</div>



